import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, Button, Typography } from '@mui/material';
import axios from 'axios';


export default function ResendDialog({ open, handleClose, email }) {
    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = async () => {
        setIsLoading(true)
        try {

            await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/resend-email`, { email })
            setIsLoading(true)
            handleClose()
        } catch (error) {
            setIsLoading(true)
            handleClose()
        }
    }
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiPaper-root': {
                        width: { xs: '350px', sm: '649px' },
                        height: 'max-content',
                        borderRadius: '20PX',
                    },
                }}
            >
                <Box sx={{ padding: 5 }}>
                    <Box>
                        <Typography>Your Account is not Verified.</Typography>
                    </Box>
                    <Box sx={{ marginTop: 4 }}>
                        <Button onClick={handleSubmit} disabled={isLoading}>Resend Email</Button>
                    </Box>
                </Box>
            </Dialog>
        </div>
    );
}
